import { apiClient } from '~/shared/api/data-ingestion-api'
import { getDisplayLabel } from './get-display-label'

export function getDisplayCategory(
  subcategoryMetadata: apiClient.SubcategoryMetadata | null | undefined,
  fallback: string | null | undefined,
) {
  if (!subcategoryMetadata) {
    return fallback ?? ''
  }

  const phase = getDisplayLabel(subcategoryMetadata.phase || '')
  let withinParentheses = subcategoryMetadata.outcome
    ? getDisplayLabel(subcategoryMetadata.outcome)
    : ''
  withinParentheses += subcategoryMetadata.reason
    ? `: ${getDisplayLabel(subcategoryMetadata.reason)}`
    : ''

  return `${phase}${withinParentheses ? ` (${withinParentheses})` : ''}`
}
